import React, { useEffect, useState } from "react";
import DataGrid, {
	Column,
	Editing,
	Popup,
	Form,
} from "devextreme-react/data-grid";
import { TabPanel } from "devextreme-react/tab-panel";
import { Switch } from "devextreme-react/switch";
import { getOrders, setOrders } from "../../api/apiServiceFetch";
import TextBox from "devextreme-react/text-box";
import PopupMessage from "../../components/PopupMessage";
import GeneratePayLinkPopup from "../../components/GeneratePayLinkPopup";

import "./Orders.scss";
const typeLabels = {
	0: "🖤 Plus",
	1: "💎 Platinum",
	2: "🚀 Supers",
	3: "🆕 Чистый лист",
	5: "🔄 Повторная регистрация",
};
const Orders = () => {
	const [orders, setOrdersState] = useState([]);
	const [selectedIndex, setSelectedIndex] = useState(0);
	const [starsRateCNT, setStarsRateCNT] = useState(1);
	const [usdRateCNT, setUsdRateCNT] = useState(1);
	const [isPopupMessageOpen, setIsPopupMessageOpen] = useState(false);
	const [isPayLinkPopupOpen, setIsPayLinkPopupOpen] = useState(false);
	const [usdRate, setUsdRate] = useState(
		Number(localStorage.getItem("UsdRate")) || 82
	);
	const [starsRate, setStarsRate] = useState(
		Number(localStorage.getItem("StarsRate")) || 1.8
	);

	const handleRESET = async () => {
		setUsdRate(82);
		setStarsRate(1.8);
		localStorage.setItem("UsdRate", 82);
		localStorage.setItem("StarsRate", 1.8);
	};
	useEffect(() => {
		const fetchOrders = async () => {
			try {
				const data = await getOrders();
				setOrdersState(data);
			} catch (err) {
				console.error("Ошибка загрузки:", err);
			}
		};
		fetchOrders();
	}, []);

	const handleRowUpdating = async (e) => {
		const updatedOrder = { ...e.oldData, ...e.newData };
		try {
			await setOrders(updatedOrder);
			const updated = orders.map((o) =>
				o.orderId === updatedOrder.orderId ? updatedOrder : o
			);
			setOrdersState(updated);
		} catch (err) {
			console.error("Ошибка обновления:", err);
		}
	};

	const handleToggleActive = async (order, nextActive) => {
		const prev = orders;
		const optimistic = orders.map((o) =>
			o.orderId === order.orderId ? { ...o, isActive: nextActive } : o
		);
		setOrdersState(optimistic);
		try {
			await setOrders({ ...order, isActive: nextActive });
		} catch (err) {
			console.error("Ошибка переключения isActive:", err);
			setOrdersState(prev);
			alert("Не удалось обновить статус: " + (err?.message || err));
		}
	};

	const handleToggleAllForType = async (type, nextActive) => {
		const target = orders.filter((o) => o.type === type);
		if (!target.length) return;
		const label = nextActive ? "включить" : "отключить";
		if (
			!window.confirm(
				`${label[0].toUpperCase() + label.slice(1)} все тарифы (${target.length}) в категории "${typeLabels[type]}"?`
			)
		)
			return;
		const prev = orders;
		const optimistic = orders.map((o) =>
			o.type === type ? { ...o, isActive: nextActive } : o
		);
		setOrdersState(optimistic);
		try {
			await Promise.all(
				target.map((o) => setOrders({ ...o, isActive: nextActive }))
			);
		} catch (err) {
			console.error("Ошибка массового переключения:", err);
			setOrdersState(prev);
			alert("Ошибка: " + (err?.message || err));
		}
	};

	const handleMasage = () => {
		setIsPopupMessageOpen(true);
	};
	const closeMessagePopup = () => {
		setIsPopupMessageOpen(false);
	};
	const filteredOrders = (type) => orders.filter((o) => o.type === type);

	const currencySymbols = {
		USD: "$",
		EUR: "€",
		RUB: "₽",
		STARS: "★",
	};

	const charIdToLabel = (value) => {
		if (!value) return "";
		if (value === "week") return "Неделя";
		if (value === "month") return "Месяц";
		if (value === "new") return "Чистый лист";
		if (value === "Retry") return "Повторная регистрация";
		if (value.startsWith("super")) return `Супер ${value.slice(5)}`;
		return value;
	};

	return (
		<div style={{ padding: 20 }}>
			<PopupMessage
				isOpen={isPopupMessageOpen}
				onClose={closeMessagePopup}
				type={0}
				sex={0}
			/>
			<h2>Тарифы по категориям</h2>

			<div className="filter-button">
				<button onClick={handleMasage}>Написать всем</button>
			</div>

			<div className="filter-button">
				<button onClick={() => setIsPayLinkPopupOpen(true)}>
					Сгенерировать ссылку (TBank)
				</button>
			</div>

			<div className="filter-button">
				<button onClick={handleRESET}> Сброс курса</button>
			</div>

			<GeneratePayLinkPopup
				visible={isPayLinkPopupOpen}
				onClose={() => setIsPayLinkPopupOpen(false)}
			/>
			<div
				style={{
					marginBottom: 20,
					display: "flex",
					gap: "20px",
					alignItems: "center",
				}}
			>
				<div
					style={{
						marginBottom: 20,
						display: "flex",
						gap: "20px",
						alignItems: "center",
					}}
				>
					<div>
						<span>Курс USD:</span>
						<TextBox
							width={100}
							value={usdRate}
							mode="number"
							inputAttr={{ "aria-label": "Курс USD" }}
							onValueChanged={(e) => {
								setUsdRate(Number(e.value));
								localStorage.setItem("UsdRate", Number(e.value));
							}}
						/>
						<div
							style={{
								marginTop: 10,
								display: "flex",
								gap: "20px",
								alignItems: "center",
							}}
						>
							<TextBox
								width={100}
								value={usdRateCNT}
								mode="number"
								inputAttr={{ "aria-label": "USD Количество" }}
								onInput={(e) => {
									const inputValue = e.event.target.value;
									const parsedValue =
										inputValue === "" ? 0 : Number(inputValue);
									setUsdRateCNT(parsedValue);
								}}
								onValueChanged={(e) => {
									setUsdRateCNT(Number(e.value) || 0);
								}}
							/>
							<TextBox
								width={100}
								value={`${usdRate * usdRateCNT} ₽`}
								readOnly={true}
								inputAttr={{ "aria-label": "USD в RUB" }}
							/>
						</div>
					</div>
				</div>

				<div
					style={{
						marginBottom: 20,
						display: "flex",
						gap: "20px",
						alignItems: "center",
					}}
				>
					<div>
						<span>Курс STARS:</span>
						<TextBox
							width={100}
							value={starsRate}
							mode="number"
							inputAttr={{ "aria-label": "Курс STARS" }}
							onValueChanged={(e) => {
								setStarsRate(Number(e.value));
								localStorage.setItem("StarsRate", Number(e.value));
							}}
						/>
						<div
							style={{
								marginTop: 10,
								display: "flex",
								gap: "20px",
								alignItems: "center",
							}}
						>
							<TextBox
								width={100}
								value={starsRateCNT}
								mode="number"
								inputAttr={{ "aria-label": "STARS Количество" }}
								onInput={(e) => {
									const inputValue = e.event.target.value;
									const parsedValue =
										inputValue === "" ? 0 : Number(inputValue);
									setStarsRateCNT(parsedValue); // Fixed: Correctly updates starsRateCNT
								}}
								onValueChanged={(e) => {
									setStarsRateCNT(Number(e.value) || 0);
								}}
							/>
							<TextBox
								width={100}
								value={`${starsRate * starsRateCNT} ₽`}
								readOnly={true}
								inputAttr={{ "aria-label": "STARS в RUB" }}
							/>
						</div>
					</div>
				</div>
			</div>

			<TabPanel
				showNavButtons={true}
				dataSource={Object.keys(typeLabels).map((t) => ({
					type: parseInt(t),
					title: typeLabels[t],
				}))}
				selectedIndex={selectedIndex}
				onSelectionChanged={(e) => setSelectedIndex(e.itemIndex)}
				animationEnabled={true}
				itemComponent={({ data }) => {
					const type = data.type;
					const typeOrders = filteredOrders(type);
					const allActive =
						typeOrders.length > 0 && typeOrders.every((o) => o.isActive);
					const noneActive = typeOrders.every((o) => !o.isActive);

					return (
						<>
							<div
								style={{
									display: "flex",
									gap: 10,
									marginBottom: 10,
									alignItems: "center",
								}}
							>
								<button
									type="button"
									onClick={() => handleToggleAllForType(type, true)}
									disabled={allActive}
									style={{
										padding: "6px 12px",
										background: allActive ? "#ccc" : "#22c55e",
										color: "white",
										border: "none",
										borderRadius: 4,
										cursor: allActive ? "default" : "pointer",
									}}
								>
									Включить все
								</button>
								<button
									type="button"
									onClick={() => handleToggleAllForType(type, false)}
									disabled={noneActive}
									style={{
										padding: "6px 12px",
										background: noneActive ? "#ccc" : "#ef4444",
										color: "white",
										border: "none",
										borderRadius: 4,
										cursor: noneActive ? "default" : "pointer",
									}}
								>
									Отключить все
								</button>
								<span style={{ color: "#666", fontSize: 13 }}>
									Активно: {typeOrders.filter((o) => o.isActive).length} /{" "}
									{typeOrders.length}
								</span>
							</div>

							<DataGrid
								key={type}
								dataSource={typeOrders}
								keyExpr="orderId"
								showBorders={true}
								rowAlternationEnabled={true}
								onRowUpdating={handleRowUpdating}
								onRowPrepared={(e) => {
									if (e.rowType === "data" && !e.data.isActive) {
										e.rowElement.style.opacity = 0.45;
										e.rowElement.style.background = "#fafafa";
									}
								}}
							>
								<Editing
									mode="cell"
									allowUpdating={true}
									useIcons={true}
								>
									<Popup
										title="Редактировать тариф"
										showTitle={true}
										width={420}
										height={320}
									/>
									<Form>
										<Form.Item dataField="price" />
										<Form.Item dataField="isActive" />
									</Form>
								</Editing>

								<Column
									dataField="orderId"
									caption="ID"
									width={60}
									allowEditing={false}
								/>
								<Column
									dataField="charId"
									caption="Тип"
									calculateCellValue={(data) => charIdToLabel(data.charId)}
									allowEditing={false}
								/>
								<Column
									dataField="currency"
									caption="Валюта"
									allowEditing={false}
									width={90}
								/>
								<Column
									dataField="price"
									caption="Цена"
									dataType="number"
									customizeText={({ value, data }) => {
										const symbol = currencySymbols[data?.currency] ?? "";
										return `${value} ${symbol}`;
									}}
								/>
								<Column
									caption="≈ RUB"
									calculateCellValue={(data) => {
										const { price, currency } = data;
										if (currency === "RUB" || !currency) return "";
										const rate =
											currency === "USD"
												? usdRate
												: currency === "STARS"
												? starsRate
												: null;
										if (!rate) return "";
										return `${Math.round(price * rate)} ₽`;
									}}
									allowEditing={false}
								/>
								<Column
									dataField="superLikes"
									caption="Суперлайки"
									allowEditing={false}
									width={110}
								/>
								<Column
									dataField="isActive"
									caption="Активен"
									width={110}
									allowEditing={false}
									alignment="center"
									cellRender={({ data }) => (
										<Switch
											value={!!data.isActive}
											onValueChanged={(e) =>
												handleToggleActive(data, e.value)
											}
											switchedOnText="Вкл"
											switchedOffText="Выкл"
										/>
									)}
								/>
							</DataGrid>
						</>
					);
				}}
			/>
		</div>
	);
};

export default Orders;
